export const getPatternsWithFillInfo = (patterns,cellVals)=>{

    const getCellVal = (row,col)=>{
        return cellVals[`${row}_${col}`];
    };
   
    const isCellFilled = (cellVal)=>{
        
        return cellVal !== '' && cellVal !=='*';
    };

    const patternsWithFillInfo = patterns.map(p=>{
        
        let isPatternFilled = true;
        
        const chars = [];

        if(p.direction === 0){
            for(let i = 0;i<p.word.length;i++){
                
                const cellVal = getCellVal(p.row,p.col+i);
                
                if(!isCellFilled(cellVal)){
                    isPatternFilled = false;
                    break;
                }else{
                    chars.push(cellVal);
                }
            }
        }else if(p.direction === 1){
            for(let i = 0;i<p.word.length;i++){

                const cellVal = getCellVal(p.row + i,p.col);

                if(!isCellFilled(cellVal)){
                    isPatternFilled = false;
                    break;
                }else{
                    chars.push(cellVal);
                }
            }
        }

        const word = chars.join('');               
        
        return {isPatternFilled, word,pattern:p};

    });

    return patternsWithFillInfo;

};

export const getAnswers = (patterns,cellVals)=>{
    const patternsWithFillInfo = getPatternsWithFillInfo(patterns,cellVals);
    return patternsWithFillInfo.filter(p=>p.isPatternFilled).map(p=>{
        const {row,col,direction} = p.pattern;
        const {word} = p;
        return {word,row,col,direction};
    });
};